import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "title-row" }
const _hoisted_4 = { class: "title-controls" }
const _hoisted_5 = { class: "button primary import-btn" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "default-count" }
const _hoisted_8 = { class: "filters" }
const _hoisted_9 = { class: "dropdown-button" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "spinner"
}
const _hoisted_12 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "table-wrapper with-checkbox scroll-wrapper"
}
const _hoisted_15 = { class: "table-controls" }
const _hoisted_16 = {
  key: 0,
  class: "items-count"
}
const _hoisted_17 = {
  key: 1,
  class: "items-count"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "leads-table-scroll scroll-wrapper" }
const _hoisted_20 = { class: "table-default" }
const _hoisted_21 = { class: "checkbox" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "bold" }
const _hoisted_25 = { class: "text-highlighted" }
const _hoisted_26 = {
  key: 0,
  class: "text-highlighted new-lead"
}
const _hoisted_27 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title-main" }, "Leads", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "button primary create-lead-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showCreateModal = true))
          }, "Create Lead"),
          _createElementVNode("label", _hoisted_5, [
            _cache[10] || (_cache[10] = _createTextVNode("Import Leads", -1)),
            _createElementVNode("input", {
              onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.uploadLeads($event))),
              type: "file",
              accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            }, null, 32)
          ]),
          ($setup.templateDownloadLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "button default primary download-btn",
                href: $setup.templateDownloadLink,
                target: "_blank"
              }, "Download Template", 8, _hoisted_6))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString($setup.plural($setup.leads.length, "Lead")), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode($setup["DropDown"], null, {
        control: _withCtx(() => [
          _createElementVNode("button", _hoisted_9, "Leads status is " + _toDisplayString($setup.activeFilter.label), 1)
        ]),
        dropdown: _withCtx(() => [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                onClick: ($event: any) => ($setup.changeFilter(item)),
                class: _normalizeClass({ 'dropdown__item-active': $setup.activeFilter.label === item.label })
              }, _toDisplayString(item.label), 11, _hoisted_10))
            }), 256))
          ])
        ]),
        _: 1
      }),
      _createVNode($setup["InputSearch"], {
        class: "search",
        modelValue: $setup.searchQuery,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchQuery) = $event)),
        placeholder: "Search",
        theme: "filter"
      }, null, 8, ["modelValue"])
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11))
      : ($setup.leads.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("img", {
              class: "empty-block--icon",
              src: require('@/assets/icons/contacts-slim.svg')
            }, null, 8, _hoisted_13),
            _cache[12] || (_cache[12] = _createElementVNode("p", null, "Your leads list is empty", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              ($setup.selectedLeadsList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.plural($setup.selectedLeadsList.length, "lead")) + " selected", 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($setup.plural($setup.leads.length, "lead")), 1)),
              (!$setup.isEditStatusMode)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (!$setup.isEstateCollaborator && $setup.estate)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["table-controls-button invite", { show: $setup.selectedLeadsList.length > 0 }]),
                          onClick: $setup.inviteToWaitlist
                        }, "Invite to waitlist", 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: _normalizeClass(["table-controls-button edit", { show: $setup.selectedLeadsList.length > 0 }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isEditStatusMode = true))
                    }, "Edit status", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["table-controls-button delete", { show: $setup.selectedLeadsList.length > 0 }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showConfirmBulkDeleteModal = true))
                    }, "Delete leads", 2)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["table-controls-button save", { show: $setup.selectedLeadsList.length > 0 }]),
                      onClick: $setup.bulkChangeStatuses
                    }, "Save", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["table-controls-button cancel", { show: $setup.selectedLeadsList.length > 0 }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.isEditStatusMode = false))
                    }, "Cancel", 2)
                  ], 64))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["statuses-block", { hide: !$setup.isEditStatusMode || $setup.selectedLeadsList.length === 0 }])
            }, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values($setup.LeadStatus), (status) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["badge", [$setup.getLeadStatusClass(status), { selected: $setup.newStatus === status }]]),
                    key: status,
                    onClick: ($event: any) => ($setup.newStatus = status)
                  }, _toDisplayString(status), 11, _hoisted_18))
                }), 128))
              ])
            ], 2),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("table", _hoisted_20, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_21, [
                      _createVNode($setup["CheckboxInput"], {
                        checkedPartial: $setup.selectedLeadsList.length > 0 && $setup.selectedLeadsList.length !== $setup.leadList.length,
                        modelValue: $setup.isSelectAll,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.selectAll($event)))
                      }, null, 8, ["checkedPartial", "modelValue"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.headers, (header) => {
                      return (_openBlock(), _createElementBlock("th", { key: header }, _toDisplayString(header), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.leads, (row, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: idx,
                      onClick: ($event: any) => ($setup.onRow(row._id))
                    }, [
                      _createElementVNode("td", {
                        class: "checkbox",
                        onClick: _withModifiers(($event: any) => ($setup.selectLot(!$setup.leadList[idx].selected, idx)), ["stop"])
                      }, [
                        _createVNode($setup["CheckboxInput"], {
                          onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
                          modelValue: $setup.leadList[idx].selected,
                          "onUpdate:modelValue": ($event: any) => ($setup.selectLot($event, idx))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ], 8, _hoisted_23),
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(row?.firstName) + " " + _toDisplayString(row?.lastName), 1),
                        (!row.watched)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "NEW"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(row?.email), 1),
                      _createElementVNode("td", null, _toDisplayString(row?.phone), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["badge", $setup.getLeadStatusClass(row?.status)])
                        }, _toDisplayString(row?.status), 3)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(row?.source === $setup.LeadSourceEnum.INITIAL_HOLD ? "Hold Request" : row?.source), 1),
                      _createElementVNode("td", null, _toDisplayString(row?.postcode ?? "—"), 1),
                      _createElementVNode("td", null, _toDisplayString(row?.holderType ?? "—"), 1),
                      _createElementVNode("td", null, _toDisplayString($setup.formatDate(row?.createdAt, "DD MMM YYYY")), 1),
                      ($setup.estateHasCollaborators)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_27, _toDisplayString($setup.getLeadBusiness(row)), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_22))
                  }), 128))
                ])
              ])
            ])
          ])),
    _createVNode($setup["CreateLeadModal"], {
      isOpen: $setup.showCreateModal,
      listForUpdate: $setup.leadList,
      onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.showCreateModal = false)),
      onUpdate: $setup.getLeads
    }, null, 8, ["isOpen", "listForUpdate"]),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.showConfirmBulkDeleteModal,
      deleteItem: $setup.selectedLeadsList.length,
      onClose: _cache[9] || (_cache[9] = ($event: any) => ($setup.showConfirmBulkDeleteModal = false)),
      onConfirm: $setup.bulkDeleteLeads
    }, null, 8, ["isOpen", "deleteItem"])
  ]))
}